import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/checkInSaga";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const MembershipTypeFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.checkIns.filters.membership_types);
  const selectedOption = useSelector((state) => state.checkIns.selectedFilters.membership_types);

  return (
    <div className="select-box" style={{ width: "160px" }}>
      <p className="offers-title">Membership Types</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOption}
        placeholder="Not selected"
        height={324}
        numberDisplayed={0}
        includeSelectAll
        enableOnly
        onSelectChange={(data) => dispatch(actionCreators.updateMembershipTypeFilter(data))}
      />
    </div>
  );
};

export default MembershipTypeFilter;
